
export default function TopCardDashboard({ title, count, icon, children }) {

  return (
    <>
      <div className="col-12 col-md-4 col-xl-3">
        <div className="card dash-cards">
          <div className="card-body">
            <div className="d-flex align-items-center justify-content-start gap-4">
              <div className="icon d-none">
                {icon}
              </div>
              <div>
                <h1 className=" fw-medium mb-2">{title}</h1>
                <h3>{count}</h3>
                <p>{children}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
